export const KINDS = {
  PRIMARY: 'Primary',
  SECONDARY: 'Secondary',
  TERTIARY: 'Tertiary',
  GHOST: 'Ghost',
  LINK: 'Link',
  ERROR: 'Error',
  ERROR_SECONDARY: 'ErrorSecondary',
} as const

export const PADDING = {
  FLUID: 'Fluid',
  FIXED: 'Fixed',
} as const

export const SIZES = {
  LARGE: 'Large',
  REGULAR: 'Regular',
  SMALL: 'Small',
} as const

export const TYPES = {
  BUTTON: 'button',
  SUBMIT: 'submit',
} as const
